import React from 'react';

export const TippinWidget = () => {
  return <iframe title="Tippin.me widget" src="https://tippin.me/buttons/send-lite.php?u=parallelpoliske" height="475px" />
}
